import { api } from '@shared/api/api';

type VenueData = App.Domain.Event.Data.VenueData;

export type CreateVenueData = Omit<App.Domain.Event.Data.VenueData, 'id' | 'createdAt' | 'updatedAt'>;

export const createVenue = api.createCreate<CreateVenueData, VenueData>('venues');
